const NAVIGATION_PROTOCOLS = new Set(['http:', 'https:', 'mailto:', 'tel:'])
const MEDIA_PROTOCOLS = new Set(['http:', 'https:', 'blob:', 'data:'])
export const UNSAFE_NAVIGATION_URL = 'about:blank#unsafe-navigation-url'
export const UNSAFE_MEDIA_URL = 'about:blank#unsafe-media-url'

function parseUrl(input: string): URL | null {
  try {
    return new URL(input, window.location.origin)
  } catch {
    return null
  }
}

export function sanitizeNavigationUrl(url?: string): string | undefined {
  if (!url?.trim()) return undefined
  const parsed = parseUrl(url)
  if (!parsed) return undefined
  if (!NAVIGATION_PROTOCOLS.has(parsed.protocol.toLowerCase())) return undefined
  return parsed.toString()
}

export function sanitizeMediaUrl(url?: string): string | undefined {
  if (!url?.trim()) return undefined
  const parsed = parseUrl(url)
  if (!parsed) return undefined
  if (!MEDIA_PROTOCOLS.has(parsed.protocol.toLowerCase())) return undefined
  return parsed.toString()
}

export function openSafeInNewTab(url?: string): boolean {
  const safeUrl = sanitizeNavigationUrl(url)
  if (!safeUrl) return false
  window.open(safeUrl, '_blank', 'noopener,noreferrer')
  return true
}

export function toSafeNavigationUrl(url?: string): string {
  return sanitizeNavigationUrl(url) ?? UNSAFE_NAVIGATION_URL
}

export function toSafeMediaUrl(url?: string): string {
  return sanitizeMediaUrl(url) ?? UNSAFE_MEDIA_URL
}
